import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useHealthlinkCredentialsSave = () => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error saving practice");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const mutation = useMutation({
    mutationFn: async ({ login, password, pin, id }) => {
      const axiosInstance = createAxiosInstance();

      if (id) {
        const response = await axiosInstance.put(
          `${tenantVal}/healthlink/credentials/${id}`,
          {
            login,
            password,
            pin,
          }
        );
        return response.data;
      }

      const response = await axiosInstance.post(
        `${tenantVal}/healthlink/credentials`,
        {
          login,
          password,
          pin,
        }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Credentials saved");
      queryClient.invalidateQueries({ queryKey: ["healthlinkPractice"] });
      queryClient.invalidateQueries({ queryKey: ["healthMailLoginDetails"] });
    },
    onError: handleNetworkError,
  });

  return mutation;
};
